import { render, staticRenderFns } from "./AddMailAdvisor.vue?vue&type=template&id=4680214a&scoped=true&"
import script from "./AddMailAdvisor.vue?vue&type=script&lang=ts&"
export * from "./AddMailAdvisor.vue?vue&type=script&lang=ts&"
import style0 from "./AddMailAdvisor.vue?vue&type=style&index=0&id=4680214a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680214a",
  null
  
)

export default component.exports